var map = {
	"./Basics.png": "OOvY",
	"./Purchase.png": "W+cO",
	"./Report.png": "CXL8",
	"./Sale.png": "eZ3N",
	"./Warehouse.png": "An67",
	"./capital.png": "fiOd",
	"./icon2/Accounts.png": "B1+U",
	"./icon2/Bill.png": "LRDe",
	"./icon2/Collection.png": "Y4Ik",
	"./icon2/Company.png": "YyGX",
	"./icon2/Dealings.png": "b5bH",
	"./icon2/Document.png": "LI09",
	"./icon2/Initial.png": "MDdc",
	"./icon2/Jurisdiction.png": "vKv4",
	"./icon2/Management.png": "ifaj",
	"./icon2/Other.png": "dwHD",
	"./icon2/Report.png": "lEr2",
	"./icon2/Sale.png": "OUBt",
	"./icon2/Stock.png": "fZ4G",
	"./icon2/account.png": "2j/W",
	"./icon2/adjustment.png": "+y/J",
	"./icon2/allocation.png": "hYLM",
	"./icon2/business.png": "jCSK",
	"./icon2/commodity.png": "tPkm",
	"./icon2/core.png": "7JE4",
	"./icon2/mechanism.png": "1eF+",
	"./icon2/system.png": "1ftQ",
	"./icon2/wholesale.png": "GBpx",
	"./system.png": "b3kQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbyb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lefticon ^\.\/.*$
// module id = fbyb
// module chunks = 95